import { styled } from 'next-yak'

import * as input from './input'

import * as colors from '../../constants/colors'

export const Wrapper = styled(input.ComposedWrapper)`
  position: relative;
`

export const Input = styled(input.Input)`
  width: 100%;
  order: 2;
  padding-left: 0;
`

export const CountryPrefix = styled.span`
  color: ${colors.TEXT_TERTIARY};
`

export const CountryName = styled.span``
